import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { useGetPostReactionsQuery } from "../../api/engageApi";
import { initials, normalizeReactionGroups } from "./constants";

const ReactionsDialog = ({ open, segment, postId, onClose }) => {
  const { data, isLoading, isError } = useGetPostReactionsQuery(
    { segment, postId },
    { skip: !open || !segment || !postId }
  );

  const groups = normalizeReactionGroups(data);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <span className="text-lg font-semibold text-gray-800">Reactions</span>
      </DialogTitle>

      <DialogContent dividers>
        {isLoading && (
          <div className="flex justify-center py-8">
            <CircularProgress size={26} />
          </div>
        )}

        {isError && (
          <p className="py-6 text-sm text-red-600">
            Could not load who reacted. Close this and try again.
          </p>
        )}

        {!isLoading && !isError && groups.length === 0 && (
          <p className="py-6 text-sm text-gray-500">No reactions yet.</p>
        )}

        {groups.map((group) => (
          <div key={group.emoji} className="mb-3 last:mb-0">
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-gray-400">
              <span className="text-base">{group.emoji}</span>
              <span>{group.count}</span>
            </p>
            {group.reactors.map((person) => (
              <div
                key={`${group.emoji}-${person.employeeId || person.name}`}
                className="flex items-center gap-2.5 px-1 py-1.5 text-sm text-gray-700"
              >
                <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full border border-green-500 bg-white text-[10px] font-semibold text-gray-700">
                  {initials(person.name)}
                </span>
                <span className="truncate">{person.name}</span>
              </div>
            ))}
          </div>
        ))}
      </DialogContent>

      <DialogActions>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Done
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ReactionsDialog;
